import { GET_LOCATIONS } from '../../actions';

const getInitialState = {
  get: { error: null, loaded: false, loading: false, data: [] },
};

/**
 * locations reducer.
 * @function locations
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export const locationsReducer = (state = getInitialState, action = {}) => {
  switch (action.type) {
    case `${GET_LOCATIONS}_PENDING`:
      return {
        ...state,
        get: {
          ...state.get,
          error: null,
          loaded: false,
          loading: true,
          data: [],
        },
      };
    case `${GET_LOCATIONS}_FAIL`:
      return {
        ...state,
        get: {
          ...state.get,
          error: action.error,
          loaded: false,
          loading: false,
          data: [],
        },
      };
    case `${GET_LOCATIONS}_SUCCESS`:
      return {
        ...state,
        get: {
          ...state.get,
          error: null,
          loaded: true,
          loading: false,
          data: action.result,
        },
      };
    default:
      return state;
  }
};
